var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.25C4.41421 13.25 4.75 13.5858 4.75 14V21C4.75 21.4142 4.41421 21.75 4 21.75C3.58579 21.75 3.25 21.4142 3.25 21V14C3.25 13.5858 3.58579 13.25 4 13.25Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53554 3.83045C4.99216 2.68161 8.46313 1.29018 12.1021 3.17181L11.7576 3.83801L12.1021 3.17181C14.5493 4.43719 17.1998 4.45671 19.6895 3.3245C19.9217 3.21893 20.1916 3.23856 20.406 3.37661C20.6204 3.51465 20.75 3.7522 20.75 4.00722V14.0223C20.75 14.2948 20.6022 14.5459 20.3639 14.6781C18.8193 15.5352 15.1657 16.5954 11.4131 14.655C7.89309 12.8349 5.34888 14.417 4.56575 15.3169C4.36038 15.5528 4.03012 15.6366 3.73714 15.5269C3.44416 15.4173 3.25 15.1373 3.25 14.8245V4.41933C3.25 4.18967 3.35522 3.97267 3.53554 3.83045ZM4.75 4.80241V13.2638C6.36316 12.3036 8.96929 11.7027 12.1021 13.3226L12.1021 13.3226C14.9923 14.817 17.8222 14.2027 19.25 13.559V5.10894C16.6639 5.9794 13.9374 5.80947 11.4131 4.50422L11.699 3.95138L11.4131 4.50422C8.66558 3.08353 6.03069 3.954 4.75 4.80241Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlag);
export default __webpack_public_path__ + "static/media/ic-flag.8b6322b734fe0bba584c472cc8430dc8.svg";
export { ForwardRef as ReactComponent };